export function nextAnimationFrame(): Promise<void> {
  return new Promise((res) => {
    requestAnimationFrame(() => res());
  });
}
